import {Component, Input} from "@angular/core";

/**
 * Component for showing a download teaser with button.
 */
@Component({
    selector: 'app-download',
    templateUrl: './download.component.html',
    standalone: false
})
export class DownloadComponent {
  /**
   * Download URL for the CTA button
   */
  @Input() url: string;

  /**
   * prefix for the textkeys
   */
  @Input() textkeyPrefix: string;

  /**
   * Toggle for the PDF icon
   */
  @Input() pdfIcon: boolean = true;

  /**
   * URL for showing an image next to the text
   */
  @Input() imageUrl: string = null;

}
